import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { Globals } from '../../../globals'
import { IepService } from "../../../Services/IepService";
import { ISpedStudentDemographics } from '../../../Models/ISpedStudentDemographics'
import { IIepInstance } from '../../../Models/IIepInstance'
import { Message, SelectItem } from 'primeng/primeng';
import { ILockStatus } from '../../../Models/ILockStatus';
import { InitialIEPInfoService } from "../../../Services/InitialIEPInfoService";
import { IInitialIEPInfo } from "../../../Models/IInitialIEPInfo";
import { ILookupBase } from '../../../Models/ILookupBase';
import { LookupService } from 'src/app/Services/LookupService';
import { LookupTypeEnum } from 'src/app/Models/Enums/LookupTypeEnum';
import { FormRevokingConsentService } from "../../../Services/FormRevokingConsentService";
import { IFormRevokingConsent } from "../../../Models/Forms/IFormRevokingConsent";
import { IReportParameter } from 'src/app/Models/IReportParameter';
import { ReportService } from 'src/app/Services/ReportService';
import { SpinnerBase } from '../../Base/SpinnerBase';
import { ISelectedStudent } from '../../../Models/ISelectedStudent';
import {DialogModule} from 'primeng/dialog';
import { SelectedStudentService } from '../../../Services/SelectedStudentService';
import { Subscription } from 'rxjs';
import { saveAs } from 'file-saver';

@Component({
  selector: 'InitialIEPInfo',
  templateUrl: './InitialIEPInfo.component.html',
  styleUrls: ['./InitialIEPInfo.component.css']
})

export class InitialIEPInfoComponent extends SpinnerBase implements OnInit, OnDestroy {
  _myGlobals: Globals;
  _baseUrl: string;
  _iepService: IepService;
  successMessages: Message[];
  errorMessages: Message[];
  studentInfo: ISpedStudentDemographics;
  selectedIepInstance: IIepInstance;
  isLocked: boolean;
  lockStatus: string;
  canEditIep: boolean;
  saveClicked: boolean;
  iepInfoEditMode: boolean = false;
  initialiepDB: IInitialIEPInfo = {} as IInitialIEPInfo;
  formRevokingConsentDB: IFormRevokingConsent = {} as IFormRevokingConsent;
  lookupReferredBy: ILookupBase[];
  lookupWithdrawReason: ILookupBase[];
  disabilityCodeOptions: SelectItem[];
  _lookupService: LookupService;
  _formRevokingConsentService: FormRevokingConsentService;
  _lookupTypeEnum: LookupTypeEnum;
  today: Date;
  TenDaysOut: Date;
  TwentyYearsBackDate: Date;
  RangeTwentyYearsBack: string;
  reportParamArray: IReportParameter[];
  IsOpenIEPInfoPopup : boolean = false;
  IsDisablePrimaryDisabilityDropdown: boolean = false;
  IsShowScannedDocuments: boolean = false;
  showDisability: boolean = false;

  InitialIepInfoSubscription: Subscription;

  constructor(
    private globals: Globals,
    reportService: ReportService,
    private _initialIEPInfoService: InitialIEPInfoService,
    private _selectedStudentService: SelectedStudentService,
    iepService: IepService,
    lookupService: LookupService,
    formRevokingConsentService: FormRevokingConsentService,
    @Inject('BASE_URL') baseUrl: string) {
    super(reportService);
    this._iepService = iepService;
    this._myGlobals = globals;
    this._baseUrl = baseUrl;
    this.studentInfo = this._myGlobals.spedStudentDemographics;
    this.selectedIepInstance = this._myGlobals.selectedIepInstance;
    this._lookupService = lookupService;
    this._formRevokingConsentService = formRevokingConsentService;
  }

  ngOnInit(): void {
    this.LoadInitialIEPInfoDetails();
    this.LoadFormRevokingConsentDetails();
    this.LoadLookupValues();
    this.isLocked = false;
    this.IsOpenIEPInfoPopup = false;
    this.canEditIep = this._myGlobals.canEditInitialIEPInfo();
    this.today = new Date();
    this.TwentyYearsBackDate = new Date(this.today.getFullYear() - 20, 5, 1);
    this.RangeTwentyYearsBack = this.today.getFullYear() - 20 + ':' + this.today.getFullYear();
    if (this.today.getDate() <= 20) {
      this.TenDaysOut = new Date(this.today.getFullYear(), this.today.getMonth(), this.today.getDate() + 10);
    } else {
      this.TenDaysOut = new Date(this.today.getFullYear(), this.today.getMonth() + 1, this.today.getDate() - 20);
    }

    this.InitialIepInfoSubscription = this._selectedStudentService.getInitialIepInfo().subscribe(
      (info: IInitialIEPInfo) => {
        this.LoadInitialIEPInfoDetailsFromExisting(info);
      }
    )
  }

  ngOnDestroy() {
    this.InitialIepInfoSubscription.unsubscribe();
  }

  LoadInitialIEPInfoDetails(): void {
    this._initialIEPInfoService.getInitialIEPInfo(this._myGlobals.selectedStudent.localStudentId)
      .subscribe((res: IInitialIEPInfo) => {
        this.initialiepDB = res,
        this.initialiepDB.identifiedAsSPEDDate = this.initialiepDB.identifiedAsSPEDDate == null ? null : new Date(this.initialiepDB.identifiedAsSPEDDate);
        this.initialiepDB.initialConsentDate = this.initialiepDB.initialConsentDate == null ? null : new Date(this.initialiepDB.initialConsentDate);
        this.initialiepDB.initialIepDate = this.initialiepDB.initialIepDate == null ? null : new Date(this.initialiepDB.initialIepDate);
        this.initialiepDB.spedEntryDate = this.initialiepDB.spedEntryDate == null ? null : new Date(this.initialiepDB.spedEntryDate);
        this.initialiepDB.initialEvalDate = this.initialiepDB.initialEvalDate == null ? null : new Date(this.initialiepDB.initialEvalDate);
        this.initialiepDB.lastEvalDate = this.initialiepDB.lastEvalDate == null ? null : new Date(this.initialiepDB.lastEvalDate);
        this.initialiepDB.mostRecentLaserficheDocumentUpdatedBy = this.initialiepDB.mostRecentLaserficheDocumentUpdatedBy == null ? '' : this.initialiepDB.mostRecentLaserficheDocumentUpdatedBy;
        this.initialiepDB.mostRecentLaserficheDocumentUpdatedOn = this.initialiepDB.mostRecentLaserficheDocumentUpdatedOn == null ? null : new Date(this.initialiepDB.mostRecentLaserficheDocumentUpdatedOn);
        this.initialiepDB.mostRecentLaserficheDocumentId=this.initialiepDB.mostRecentLaserficheDocumentId == null ? null : this.initialiepDB.mostRecentLaserficheDocumentId;
        this.initialiepDB.spedIdentifierIdString = this.initialiepDB.spedIdentifierId == null ? '' : this.initialiepDB.spedIdentifierId.toString();
        this.initialiepDB.withdrawlReason = this.initialiepDB.withdrawlReason == null ? "" : this.initialiepDB.withdrawlReason.toString();
        this.initialiepDB.enteredBy = this._myGlobals.spedSecurityUser.userNameEmail;
        this.initialiepDB.updatedBy = this._myGlobals.spedSecurityUser.userNameEmail;
        if (this.initialiepDB.datePermissionRevoked != null) {
          this.initialiepDB.datePermissionRevoked = new Date(this.initialiepDB.datePermissionRevoked);
        }
        if (this.initialiepDB.dateScanned != null) {
          this.initialiepDB.dateScanned = new Date(this.initialiepDB.dateScanned);
        }

        this._selectedStudentService.setInitialIepInfo(this.initialiepDB);
      },
        err => {
          console.error(err);
          let errorMessage: Message = { severity: 'error', summary: 'There was no Initial IEP Info found for this student.  Please create Initial IEP Information.', detail: null };          

          this.initialiepDB = {
            id: 0,
            localStudentId: '',
            datePermissionRevoked: null,
            dateScanned: null,
            enteredBy: '',
            entryDate: null,
            identifiedAsSPEDDate: null,
            initialConsentDate: null,
            initialEvalDate: null,
            initialIepDate: null,
            lastEvalDate: null,
            mostRecentLaserficheDocumentId: 0,
            mostRecentLaserficheDocumentUpdatedBy: null,
            mostRecentLaserficheDocumentUpdatedOn: null,
            primaryDisabilityCode: '',
            scannedToStudentFolderNo: false,
            scannedToStudentFolderYes: false,
            spedEntryDate: null,
            spedIdentifierName: '',
            spedIdentifierDescription: '',
            spedIdentifierId: 0,
            spedIdentifierIdString: '',
            spedPermissionRestored: false,
            spedPermissionRevoked: false,
            withdrawlReason: '',
            writtenRequestReceivedNo: false,
            writtenRequestReceivedYes: false,
            updatedOn: null,
            updatedBy: '',
            updatedIP: ''
          };

          this._selectedStudentService.setInitialIepInfo(this.initialiepDB);
        }
      );
  }

  LoadInitialIEPInfoDetailsFromExisting(info: IInitialIEPInfo): void {
    this.showDisability = info.primaryDisabilityCode ? true : false;
    info.identifiedAsSPEDDate = info.identifiedAsSPEDDate == null ? null : new Date(info.identifiedAsSPEDDate);
    info.initialConsentDate = info.initialConsentDate == null ? null : new Date(info.initialConsentDate);
    info.initialIepDate = info.initialIepDate == null ? null : new Date(info.initialIepDate);
    info.spedEntryDate = info.spedEntryDate == null ? null : new Date(info.spedEntryDate);
    info.initialEvalDate = info.initialEvalDate == null ? null : new Date(info.initialEvalDate);
    info.lastEvalDate = info.lastEvalDate == null ? null : new Date(info.lastEvalDate);
    this.initialiepDB.mostRecentLaserficheDocumentUpdatedBy = this.initialiepDB.mostRecentLaserficheDocumentUpdatedBy == null ? '' : this.initialiepDB.mostRecentLaserficheDocumentUpdatedBy;
    this.initialiepDB.mostRecentLaserficheDocumentUpdatedOn = this.initialiepDB.mostRecentLaserficheDocumentUpdatedOn == null ? null : new Date(this.initialiepDB.mostRecentLaserficheDocumentUpdatedOn);
    this.initialiepDB.mostRecentLaserficheDocumentId=this.initialiepDB.mostRecentLaserficheDocumentId == null ? null : this.initialiepDB.mostRecentLaserficheDocumentId;
    info.spedIdentifierIdString = info.spedIdentifierId == null ? '' : info.spedIdentifierId.toString();
    info.withdrawlReason = info.withdrawlReason == null ? "" : info.withdrawlReason.toString();
    info.enteredBy = this._myGlobals.spedSecurityUser.userNameEmail;
    info.updatedBy = this._myGlobals.spedSecurityUser.userNameEmail;
    if (info.datePermissionRevoked != null) {
      info.datePermissionRevoked = new Date(info.datePermissionRevoked);
    }
    if (info.dateScanned != null) {
      info.dateScanned = new Date(info.dateScanned);
    }

    this.initialiepDB = info;
  }

  LoadFormRevokingConsentDetails(): void {
    this._formRevokingConsentService.getMostRecentFormRevokingConsent(this._myGlobals.selectedStudent.localStudentId)
      .subscribe((res: IFormRevokingConsent) => {
        if (!res || res.toString() === "") {
          this.formRevokingConsentDB = {} as IFormRevokingConsent;
          this.formRevokingConsentDB.localStudentId = this._myGlobals.selectedStudent.localStudentId;
          this.formRevokingConsentDB.iepId = this._myGlobals.selectedIepInstance.iepId;
          this.formRevokingConsentDB.iepInstanceId = this._myGlobals.selectedIepInstance.id;
          this.formRevokingConsentDB.childName = this._myGlobals.selectedStudent.studentName;
          this.formRevokingConsentDB.siteName = this._myGlobals.selectedStudent.siteName;
          this.formRevokingConsentDB.updatedBy = this._myGlobals.spedSecurityUser.userNameEmail;
        }
        else {
          this.formRevokingConsentDB = res;
          this.formRevokingConsentDB.dateOfNotice = this.formRevokingConsentDB.dateOfNotice == null ? null : new Date(this.formRevokingConsentDB.dateOfNotice);
          this.formRevokingConsentDB.dateOn = this.formRevokingConsentDB.dateOn == null ? null : new Date(this.formRevokingConsentDB.dateOn);
          this.formRevokingConsentDB.endOfServicesDate = this.formRevokingConsentDB.endOfServicesDate == null ? null : new Date(this.formRevokingConsentDB.endOfServicesDate);
          this.formRevokingConsentDB.updatedBy = this._myGlobals.spedSecurityUser.userNameEmail;
        }
      });
  }

  LoadLookupValues() {
    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ReferredBy])
      .subscribe((res: ILookupBase[]) => {
        this.lookupReferredBy = [{ value: null, label: "-- Select One --", shortText: null, updatedOn: null }].concat(res);
      },
        err => console.error(err)
    );

    this._lookupService.getLookupArray(this._baseUrl + 'api/Lookup/GetLookupList?lookupTableName=' + LookupTypeEnum[LookupTypeEnum.ExitReason])
      .subscribe((res: ILookupBase[]) => {
        this.lookupWithdrawReason = [{ value: null, label: "-- Select One --", shortText: null, updatedOn: null }].concat(res);
      },
        err => console.error(err)
    );

    this.disabilityCodeOptions = [];
    this._lookupService.getLookupArray(`${this._baseUrl}api/Lookup/GetLookupList?lookupTableName=${LookupTypeEnum[LookupTypeEnum.Disability]}`)
      .subscribe((res: ILookupBase[]) => {
        let disabilityOptions: SelectItem[] = [];
        disabilityOptions.push({ value: null, label: "-- Select One --" });

        for (let disability of res) {
          disabilityOptions.push({value : disability.value, label: disability.label})
        }
        this.disabilityCodeOptions = disabilityOptions;
      },
        err => console.error(err)
      );
  }

  clearMessages() {
    this.successMessages = [];
    this.errorMessages = [];
  }

  addMessage(msg: Message) {
    if (msg.severity == 'error') {
      this.errorMessages = [...this.errorMessages, msg];
    }
    else {
      this.successMessages = [...this.successMessages, msg];
    }
  }

  edit() {
    this.clearMessages();
    this.saveClicked = false;
  }

  onShowDisability() {
    this.showDisability = true;
  }

  //Save 
  save(action) {
    
    this.clearMessages();
    this.saveClicked = true;

    switch (this.initialiepDB.spedIdentifierIdString) {
      case "1":
        this.initialiepDB.spedIdentifierName = '10';
        break;
      case "2":
        this.initialiepDB.spedIdentifierName = '20';
        break;
      case "3":
        this.initialiepDB.spedIdentifierName = '30';
        break;
      case "4":
        this.initialiepDB.spedIdentifierName = '40';
        break;
      case "5":
        this.initialiepDB.spedIdentifierName = '90';
        break;
    }

    if (!this.initialiepDB.localStudentId) {
      this.initialiepDB.localStudentId = this._myGlobals.selectedStudent.localStudentId;
    }

    if (this.initialiepDB.updatedOn == null || this.initialiepDB.updatedOn == undefined) {
      this.initialiepDB.updatedOn = new Date();
    }

    //update InitialIEPInfo values
    this._initialIEPInfoService.insertUpdateInitialIEPInfo(this.initialiepDB)
      .subscribe((res: IInitialIEPInfo) => {
        let successMessage: Message = { severity: 'success', summary: 'InitialIEPInfo Record Saved Successfully.  Record Id: ', detail: res.id.toString() + ' at: ' + new Date().toLocaleTimeString() }
        this.addMessage(successMessage);
        if (action == 'Close') {
          this.globals.editMode = false;
          this.iepInfoEditMode = false;
        }
        this.saveClicked = false
        this.LoadInitialIEPInfoDetails();
        this.Validate();
      },
        (error) => {
          let errorMessage: Message = { severity: 'error', summary: 'Save Failed', detail: error };
          this.addMessage(errorMessage);
          this.saveClicked = false;
          this.iepInfoEditMode = false;
        }
    )

    //update FormRevokingConsent values
    if (this.initialiepDB.withdrawlReason == "7") {
      if (this.formRevokingConsentDB.id == 0) {
        this.formRevokingConsentDB.dateOfNotice = this.formRevokingConsentDB.dateOn;
        this.formRevokingConsentDB.recipientName = this.formRevokingConsentDB.sincerelyName;
      }
      this._formRevokingConsentService.insertUpdateFormRevokingConsent(this.formRevokingConsentDB)
        .subscribe((res: IFormRevokingConsent) => {
          let successMessage: Message = { severity: 'success', summary: 'RevokingConsent Record Saved Successfully.  Record Id: ', detail: res.id.toString() + ' at: ' + new Date().toLocaleTimeString() }
          this.addMessage(successMessage);
        },
          (error) => {
            let errorMessage: Message = { severity: 'error', summary: 'RevokingConsent Save Failed', detail: error };
            this.addMessage(errorMessage);
          }
        )
    }

  }

  Validate() {
    this.clearMessages();
    this._initialIEPInfoService.validateInitialIEPInfo(this._myGlobals.selectedStudent.localStudentId).subscribe((res: string[]) => {
      let errorMessages: string[] = res as string[];
      if (errorMessages.length == 0) {
        let successMessage: Message = { severity: 'success', summary: 'Initial IEP Information validated with zero errors', detail: '' }
        this.addMessage(successMessage);
      }
      else {
        for (var message of errorMessages) {
          let errorMessage: Message = { severity: 'error', summary: 'Validation Error - Please Correct Error:', detail: message }
          this.addMessage(errorMessage);
        }
      }
    },
      err => {
        console.error(err);
        let errorMessage: Message = { severity: 'error', summary: 'An unexpected error has occurred: ', detail: err }
        this.addMessage(errorMessage);
      }
    );
  }

  editInitialIepInfo() {
    this.IsDisablePrimaryDisabilityDropdown = true;
    this.IsShowScannedDocuments=true;
    this.clearMessages();
    switch (this._myGlobals.spedSecurityUser.roleName) {
      case 'Provider':
      case 'SiteAdministrator':
      this.IsDisablePrimaryDisabilityDropdown = false;
      this.IsShowScannedDocuments=false;
      case 'SELPA':
      this.IsDisablePrimaryDisabilityDropdown = false;
      this.IsShowScannedDocuments=false;
      case 'SysAdmin':
      this.IsDisablePrimaryDisabilityDropdown = false;
      this.IsShowScannedDocuments=false;
      case 'Clerical':
        this.iepInfoEditMode = true;
        break;
      default:
        alert("Your SPED-X role does not allow you to make changes to Initial IEP Information.");
        this.iepInfoEditMode = false;
        break;
    }
  }

  cancel() {
    this.clearMessages();
    this.globals.editMode = false;
    this.iepInfoEditMode = false;
    this.LoadInitialIEPInfoDetails();
  }

  populateReportParameters() {
    this.reportParamArray = [];
    this.reportParamArray.push(
      { parameterName: 'dtFrmEdited', parameterValue: this.formRevokingConsentDB.updatedOn.toString() },
      { parameterName: 'RequestID', parameterValue: '0' },
      { parameterName: 'isDraft', parameterValue: 'True' },
      { parameterName: 'FormInstanceID', parameterValue: this.formRevokingConsentDB.iepFormInstanceId.toString() },
      { parameterName: 'ShowCustomWaterMark', parameterValue: 'False' },
      { parameterName: 'CustomWatermarkText', parameterValue: 'DRAFT DRAFT DRAFT' },
      { parameterName: 'FormVersionID', parameterValue: '' },
      { parameterName: 'BlankForm', parameterValue: 'false' },
      { parameterName: 'IEPID', parameterValue: '0' },
      //{ parameterName: 'ReportPath', parameterValue: '' },
      { parameterName: 'isAssessment', parameterValue: 'False' }
    );
  }

  printEnglish() {
    this.populateReportParameters();
    this.printFormCommon(this.formRevokingConsentDB.rdlFileNameEnglish, this.reportParamArray);
  }

  isShowIEPInfoPopup(){
    this.IsOpenIEPInfoPopup = true;
  }
  
  showScannedDocuments(){
    this.IsShowScannedDocuments = true;
  }

  hideScannedDocuments(){
    this.IsShowScannedDocuments = false;
  }
  ViewmostRecentLaserficheDocument(mostRecentLaserficheDocumentId: number)
  {
    this._initialIEPInfoService.ViewLaserficheDocument(this._myGlobals.selectedStudent.localStudentId,mostRecentLaserficheDocumentId)
    .subscribe(result=>{ 
      const blob = new Blob([result],{type:'application/pdf'});
      saveAs(blob,"filename.pdf");
    })
  }
  
}
